import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "m-0 h-full",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "flex w-full h-full",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "questionCount" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Question", -1)
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { id: "currentQuestion" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"400"} }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { id: "allQuestions" }, "18", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionRating = _resolveComponent("QuestionRating")!
  const _component_StepperPanel = _resolveComponent("StepperPanel")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeQuestion - 21), 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(_component_Stepper, {
        linear: "",
        "unstyled:": "",
        true: "",
        "active-step": _ctx.activeSub,
        "onUpdate:activeStep": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSub) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleRelationshipsBasedOnTrust')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 22)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "22",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 23)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "23",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 24)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "24",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 25)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "25",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titlePerformanceMetricsmeasurementAndBenchmarking')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 26)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "26",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 27)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "27",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 28)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "28",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 29)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "29",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleProcessIntegrationAndCollaborativeWork')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 30)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "30",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 31)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "31",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 32)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "32",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 33)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "33",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleKnowledgeSharing')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 34)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "34",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 35)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "35",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 36)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "36",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleQuickConnectAndDisconnect')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 37)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "37",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 38)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "38",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 39)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "39",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-step"])
    ])
  ]))
}